import {
  Alert,
  AppBar,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputLabel,
  Link,
  Snackbar,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomTextField from "../CustomComponents/CustomTextField";
import { useDispatch, useSelector } from "react-redux";
import { LoanClosureReducerAction } from "../Store/LoanClosure/LoanClosureReducer";
import React, { useEffect, useRef, useState } from "react";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import { BranchAction } from "../Store/Branch";
import axios from "axios";
import LoanClosureDetail from "./LoanClosureDetail";
import { CancelTwoTone, CloseTwoTone, InfoTwoTone } from "@mui/icons-material";
import CustomConfirmationDialog from "../CustomComponents/CustomConfirmationDialog";
import { useNavigate } from "react-router-dom";
import StlapFooter from "../CustomComponents/StlapFooter";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import dayjs from "dayjs";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

const LoanClosureFilter = () => {
  const navigate = useNavigate();

  const [openDialog, setOpenDialog] = useState(false);
  const [showCloseConfirmation, setshowCloseConfirmation] = useState(false);
  const [showDeactivationConfirmation, setshowDeactivationConfirmation] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };
  const currentDate = new Date(dayjs(new Date()).format("MM/DD/YYYY"));

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const filterScreen = useSelector((state) => state.loanClosure.filterScreen);

  const valueIsValid = useSelector((state) => state.loanClosure.valueIsValid);

  const touchHandler = useSelector((state) => state.loanClosure.touchHandler);

  const userName = useSelector((state) => state.branch.userName);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  useEffect(() => {
    const branchValues = GetBranchDetails();
    dispatch(LoanClosureReducerAction.updateBranchList(branchValues));

    return () => {
      dispatch(LoanClosureReducerAction.resetLoanClosureData());
      dispatch(LoanClosureReducerAction.resetfilterScreen());
    };
  }, []);

  const branchHasError =
    touchHandler.branchTouched && !valueIsValid.branchIsValid;
  const applicationHasError =
    touchHandler.applicationNumTouched && !valueIsValid.applicationNumIsValid;

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const branchOnChangeHandler = async (value) => {
    dispatch(LoanClosureReducerAction.updateBranchValue(value));
    if (value && value !== "") {
      dispatch(LoanClosureReducerAction.updateApplicationValue(null));
      try {
        const branchCodeValue = getSelectedBranchCode(value.label);
        const response = await axios.post("/losCustomer/getLosAppNumByStatus", {
          branch: value.label,
          status: [
            "Disbursement Completed",
            "Loan Closed",
            "Disbursed",
            "Requested",
          ],
          branchCode: branchCodeValue,
        });
        dispatch(
          LoanClosureReducerAction.updateApplicationArray(response.data.sort())
        );
      } catch (error) {
        throw Error(error);
      }
    } else {
      // reset  all the values on filter
      dispatch(LoanClosureReducerAction.resetfilterScreen());
      dispatch(LoanClosureReducerAction.resetLoanClosureData());
    }
  };
  //shortcut key
  const searchButtonRef = useRef(null);
  const clearRef = useRef(null);
  const nextRef = useRef(null);
  const closeFileRef = useRef(null);
  const closeRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "loanClosureFilter",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let date = new Date();
    let refList = {
      searchButtonRef: searchButtonRef,
      nextRef: nextRef,
      closeFileRef: closeFileRef.current !== null ? closeFileRef : null,
      closeRef: closeRef.current !== null ? closeRef : null,
    };
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "d") {
        clearRef.current.click();
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "loanClosureFilter",
          })
        );
      }
    }
  };
  const applicationNumOnChangeHandler = async (value) => {
    setLoading(true);
    dispatch(LoanClosureReducerAction.updateApplicationValue(value));
    if (value && value !== "") {
      try {
        const branchCodeValue = getSelectedBranchCode(
          filterScreen.branchValue.label
        );
        const response = await axios.post("/getSantionData", {
          branch: filterScreen.branchValue.label,
          applicationNum: value,
          branchCode: branchCodeValue,
        });

        const response2 = await axios.post("/getLoanClosedData", {
          applicationNum: value,
        });
        let record2 = response2.data;
        let record = response.data;
        let filterValues = {};
        filterValues.branch = filterScreen.branchValue;
        filterValues.applicationNum = value;
        filterValues.customerName = record.customerName;
        filterValues.loanClosureDate =
          record2.loanClosureDate === null
            ? currentDate
            : record2.loanClosureDate;
        filterValues.customerId = record.customerId;
        filterValues.loanStatus = record.loanStatus;
        filterValues.sanctionAmt = record.sanctionAmt;
        filterValues.totalOsAmt = record.totalOsAmt;
        filterValues.mandateStatus = record.mandateStatus
          ? "InActive"
          : "Active";
        filterValues.emiStartDate = record.emiStartDate;
        filterValues.lastDisbDate = record.lastDisbDate;
        filterValues.sanctionedDate = record.sanctionedDate;
        dispatch(LoanClosureReducerAction.updateUsers(userName));

        const response1 = await axios.post("/getLoanClosureData", {
          applicationNum: value,
          userName: userName,
        });
        let record1 = response1.data;

        let loanClosureValues = {};

        loanClosureValues.pricipleOs = record1.pricipleOs;
        loanClosureValues.priciple = record1.priciple;
        loanClosureValues.emiOs = record1.emiOs;
        loanClosureValues.receiptAmt = record1.receiptAmt;
        loanClosureValues.simpleInterest = record1.simpleInterest;
        loanClosureValues.prePayCharge = record1.prePayCharge;
        loanClosureValues.incidentPenal = record1.incidentPenal;
        loanClosureValues.memoModelList = record1.memoModelList;
        let amountTotalMap = {};
        let paidTotal = 0;
        let dueTotal = 0;
        let waiverTotal = 0;

        record1.memoModelList.map((item) => {
          paidTotal = paidTotal + item.received;
          dueTotal = dueTotal + item.receiveable;
          waiverTotal = waiverTotal + item.earlyWaiver;
        });

        amountTotalMap.paidTotal = paidTotal;
        amountTotalMap.dueTotal = dueTotal;
        amountTotalMap.waiverTotal = waiverTotal;
        amountTotalMap.osTotal = dueTotal - paidTotal - waiverTotal;

        loanClosureValues.memoModelTotal = amountTotalMap;

        // if (record1.emiOs === 0) {
        //   filterValues.totalOsAmt =
        //     record1.closingPrinciple + amountTotalMap.osTotal;
        // } else {
        filterValues.totalOsAmt = record1.pricipleOs + amountTotalMap.osTotal;
        // }
        dispatch(LoanClosureReducerAction.updatefilterScreen(filterValues));
        dispatch(
          LoanClosureReducerAction.updateLoanClosureData(loanClosureValues)
        );
      } catch (error) {
        dispatch(LoanClosureReducerAction.resetfilterScreenForFetchValues());
        dispatch(LoanClosureReducerAction.resetLoanClosureData());
        throw Error(error);
      }
    } else {
      dispatch(LoanClosureReducerAction.resetfilterScreenForFetchValues());
      dispatch(LoanClosureReducerAction.resetLoanClosureData());
    }
    setLoading(false);
  };

  const validateData = () => {
    if (!touchHandler.branchTouched) {
      dispatch(LoanClosureReducerAction.updateBranchIsTouched(true));
      dispatch(LoanClosureReducerAction.updateBranchValue(null));
    } else if (!touchHandler.applicationNumTouched) {
      dispatch(LoanClosureReducerAction.updateApplicationNumberIsTouched(true));
      dispatch(LoanClosureReducerAction.updateApplicationValue(null));
    }

    return valueIsValid.branchIsValid && valueIsValid.applicationNumIsValid
      ? true
      : false;
  };

  const CloseButtonClickHandler = async () => {
    setLoading(true);
    setshowCloseConfirmation(false);
    try {
      let filterScreenData = { ...filterScreen };
      filterScreenData.branchCode = getSelectedBranchCode(
        filterScreen.branchValue.label
      );
      const response = await axios.post("/insertLoanClosure", filterScreenData);
      if (response.data.nachDeactivate) {
        setLoading(false);
        setMessage("Loan Application Closed Successfully..");
        setAlertType("success");
        openAlertHandler();
        setTimeout(() => {
          window.location.reload(true);
        }, 1000);
      } else {
        setLoading(false);
        setMessage("Nach Should be Deactivated Before Loan Closure.");
        setAlertType("error");
        openAlertHandler();
      }
    } catch (error) {
      setLoading(false);
      setMessage("Error Occured while saving Loan Closure.");
      setAlertType("error");
      openAlertHandler();
      throw Error(error);
    }
  };

  const DeactivateButtonClickHandler = async () => {
    setLoading(true);
    setshowDeactivationConfirmation(false);
    var nowDate = new Date();
    var date =
      nowDate.getMonth() +
      1 +
      "/" +
      nowDate.getDate() +
      "/" +
      nowDate.getFullYear();
    try {
      const branchCodeValue = getSelectedBranchCode(
        filterScreen.branchValue.label
      );
      const response = await axios.post("/nachStatusChange", {
        branch: filterScreen.branchValue.label,
        branchCode: branchCodeValue,
        applicationNum: filterScreen.applicationNum,
        deActivatedDate: date,
        remarks: "Loan Closure",
        lastModifiedBy: userName,
      });
      if (response.status === 200) {
        setMessage("Nach Deactivted Successfully.");
        setAlertType("success");
        openAlertHandler();
        dispatch(LoanClosureReducerAction.updateMandateStatus());
        setTimeout(function () {
          closeAlertHandler();
          CloseButtonClickHandler();
        }, 2000);
      } else {
        setLoading(false);
        setMessage("Nach Deactivation UnSuccessfull.");
        setAlertType("error");
        openAlertHandler();
      }
    } catch (error) {
      setLoading(false);
      setMessage("Error Occured while Nach Deactivation.");
      setAlertType("error");
      openAlertHandler();
      throw Error(error);
    }
  };

  return (
    <React.Fragment>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        {loading && (
          <>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={true}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </>
        )}
        <AccordianContainer
          id="accord"
          title="Loan Closure"
          initialOpen={true}
          sx={{ margin: "8px !important", minHeight: "100%" }}
        >
          <Box sx={{ marginTop: "-1%" }}>
            <Grid container rowSpacing={0} columnSpacing={2}>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Branch"
                  label="Branch"
                  required={true}
                  autoCompleteValues={filterScreen.branchList}
                  value={
                    filterScreen.branchValue ? filterScreen.branchValue : null
                  }
                  onChange={(event, newValue) => {
                    branchOnChangeHandler(newValue);
                    dispatch(
                      LoanClosureReducerAction.updateBranchIsTouched(true)
                    );
                    dispatch(
                      LoanClosureReducerAction.resetfilterScreenForFetchValues()
                    );
                    dispatch(
                      LoanClosureReducerAction.updateBranchValue(
                        newValue === null ? "" : newValue
                      )
                    );
                    if (newValue !== null) {
                      dispatch(BranchAction.updateInitialLoad(false));
                      dispatch(
                        BranchAction.updateHeaderBranchDetails(newValue.label)
                      );
                    }
                  }}
                />
                {branchHasError && (
                  <p className="error">Please Select Branch</p>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Application Number"
                  label="Application Number"
                  required={true}
                  autoCompleteValues={filterScreen.applicationArray}
                  value={filterScreen.applicationNum}
                  onChange={(e, newValue) => {
                    applicationNumOnChangeHandler(newValue);
                    dispatch(
                      LoanClosureReducerAction.updateApplicationNumberIsTouched(
                        true
                      )
                    );
                  }}
                />
                {applicationHasError && (
                  <p className="error">Please Select Application Number</p>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Applicant Name"
                  variant="standard"
                  placeholder="Applicant Name"
                  disabled={true}
                  value={filterScreen.customerName}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Customer Id"
                  variant="standard"
                  placeholder="Customer Id"
                  disabled={true}
                  value={filterScreen.customerId}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Sanctioned Amount (₹)"
                  variant="standard"
                  placeholder="Sanctioned Amount"
                  disabled={true}
                  value={parseInt(filterScreen.sanctionAmt).toLocaleString(
                    "en-IN"
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  label="Loan Closure Date"
                  variant="standard"
                  disabled={true}
                  disablePast={true}
                  value={filterScreen?.loanClosureDate}
                ></CustomDateField>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Loan Status"
                  variant="standard"
                  placeholder="Loan Status"
                  disabled={true}
                  value={filterScreen.loanStatus}
                />
              </Grid>

              {filterScreen.loanStatus === "Loan Closed" && (
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Loan Closure Date"
                    variant="standard"
                    placeholder="Loan Closure Date"
                    disabled={true}
                    value={new Date(
                      filterScreen.loanClosureDate
                    ).toLocaleDateString("fr-FR")}
                  />
                </Grid>
              )}

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <>
                  <div>
                    <InputLabel
                      required={false}
                      size="small"
                      sx={{
                        color: "#004A92",
                        mb: 2,
                        fontWeight: 400,
                        fontSize: "14px",
                      }}
                    >
                      {"Outstanding Amount (₹)"}
                    </InputLabel>

                    {filterScreen.totalOsAmt !== 0 &&
                    filterScreen.totalOsAmt !== ""
                      ? parseInt(filterScreen.totalOsAmt).toLocaleString(
                          "en-IN"
                        )
                      : 0}
                    {filterScreen.totalOsAmt >= 0 &&
                      filterScreen.totalOsAmt !== "" && (
                        <>
                          <Tooltip title="View Details(Ctrl+F)">
                            <IconButton
                              onClick={() => {
                                setOpenDialog(true);
                              }}
                              ref={searchButtonRef}
                              sx={{ color: "blue" }}
                            >
                              <InfoTwoTone />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                  </div>
                </>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  type="text"
                  label="Mandate Status"
                  variant="standard"
                  placeholder="Mandate Status"
                  disabled={true}
                  value={filterScreen.mandateStatus}
                />
              </Grid>
            </Grid>
            <Box
              sx={{
                marginTop: "8px",
                marginBottom: "4px",
                display: "flex",
                gap: "8px",
                justifyContent: "center",
              }}
            >
              <Tooltip title="Ctrl+Q" placement="top">
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ height: "2rem", fontWeight: "bold" }}
                  onClick={() => {
                    if (validateData()) {
                      if (filterScreen.mandateStatus === "Active") {
                        setshowDeactivationConfirmation(true);
                      } else {
                        setshowCloseConfirmation(true);
                      }
                    }
                  }}
                  ref={closeFileRef}
                  disabled={
                    filterScreen.totalOsAmt === "" ||
                    filterScreen.totalOsAmt !== 0 ||
                    filterScreen.loanStatus === "Loan Closed"
                  }
                >
                  Close File
                </Button>
              </Tooltip>
              <Tooltip title="Ctrl+G" placement="top">
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ height: "2rem", fontWeight: "bold" }}
                  disabled={!(filterScreen.totalOsAmt < 0)}
                  onClick={() => {
                    navigate("/stlap/home/filePaymentCreate");
                  }}
                  ref={nextRef}
                >
                  Process Refund
                </Button>
              </Tooltip>
              <Tooltip title="Ctrl+D" placement="top">
                <Button
                  sx={{
                    color: "white",
                    backgroundColor: "black",
                    height: "2rem",
                    fontWeight: "bold",
                  }}
                  onMouseOver={({ target }) => {
                    target.style.backgroundColor = "black";
                    target.style.color = "white";
                  }}
                  variant="contained"
                  onClick={() => {
                    dispatch(LoanClosureReducerAction.updateBranchValue(null));
                    dispatch(LoanClosureReducerAction.resetfilterScreen());
                    dispatch(LoanClosureReducerAction.resetAllTouchHandlers());
                    dispatch(LoanClosureReducerAction.resetLoanClosureData());
                  }}
                  ref={clearRef}
                >
                  Clear
                </Button>
              </Tooltip>
            </Box>
          </Box>
        </AccordianContainer>
        <Snackbar
          open={alert}
          autoHideDuration={6000}
          anchorOrigin={{ vertical, horizontal }}
          onClose={closeAlertHandler}
        >
          <Alert
            onClose={closeAlertHandler}
            severity={alertType}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>

        <Dialog
          onClose={handleClose}
          open={openDialog}
          maxWidth={"md"}
          sx={{ marginTop: "60px" }}
          fullScreen
        >
          <DialogTitle>
            Outstanding Details
            <Tooltip title="Ctrl+Q" placement="top">
              <Button
                sx={{
                  color: "white",
                  backgroundColor: "black",
                  height: "2rem",
                  fontWeight: "bold",
                  float: "right",
                }}
                onMouseOver={({ target }) => {
                  target.style.backgroundColor = "black";
                  target.style.color = "white";
                }}
                variant="contained"
                onClick={handleClose}
                ref={closeRef}
              >
                Close
              </Button>
            </Tooltip>
          </DialogTitle>
          <DialogContent>
            <LoanClosureDetail />
          </DialogContent>
        </Dialog>

        <CustomConfirmationDialog
          dialogOpen={showCloseConfirmation}
          onDialogClose={(event, reason) => {
            if (reason && reason == "backdropClick") {
              return;
            } else {
              setshowCloseConfirmation(false);
            }
          }}
          dialogTitle={"Confirmation"}
          dialogContent={"Do you really want to Close the File ?"}
          cancelButtonName={"Cancel"}
          hideCancelButton={false}
          okButtonName={"Yes"}
          onOkClick={CloseButtonClickHandler}
        />

        <CustomConfirmationDialog
          dialogOpen={showDeactivationConfirmation}
          onDialogClose={(event, reason) => {
            if (reason && reason == "backdropClick") {
              return;
            } else {
              setshowDeactivationConfirmation(false);
            }
          }}
          dialogTitle={"Confirmation"}
          dialogContent={
            "Do you really want to Deactivate All Available Mandates and Close the File ?"
          }
          cancelButtonName={"Cancel"}
          hideCancelButton={false}
          okButtonName={"Yes"}
          onOkClick={DeactivateButtonClickHandler}
        />
      </Box>
      <StlapFooter />
    </React.Fragment>
  );
};
export default LoanClosureFilter;
